import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';

import { URL_SERVICIOS_LOCALES, NUBE_AWS, URL_SERVICIOS_AWS } from '../../config/url.servicio'
import { ElectronService } from 'ngx-electron';

@Injectable()
export class CentroDeCostosProvider {

  constructor(public http: Http,private _electronService: ElectronService) {
  }

  buscar (text,companiasId:any){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarcentroDeCostos",
        parameters : {nombre: text, companiasId:companiasId}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option

      return this.http.post(`${url_servicio}/procedure`, data, options)
          .map((data: any) =>
           {
             let  dataNew = JSON.parse(data._body).data
             return dataNew[0].map((item, index) => {
                return {
                  display: item.nombre,
                  value: item.centroDeCostosId
              }})});
    } else {
    const url = `${URL_SERVICIOS_LOCALES}/proceso/buscarcentroDeCostos?nombre=${text}`;
    return this.http
        .get(url)
        .map(data => data.json()[0].map(item => {
            return {
                display: item.nombre,
                value: item.centroDeCostosId
            }
        } ));
      }
}

buscarProductoDesconect(RUTA_MODO_DESCONECTADO){
    let result  = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-CentroDeCostos',RUTA_MODO_DESCONECTADO)

        let resultNew = []
    if(result){

            let data = JSON.parse( result)
            let dataRealJson =  []
            for(let i =0 ; i<data.length;i++){
                resultNew.push([
             {       display: data[i]['nombre'],
                    value: data[i]['centroDeCostosId']
            }])

        }
            }
            result = resultNew
            return result
        }



        buscarCentroDeCostosGestion (companiasId:any){
            let url_servicio = URL_SERVICIOS_AWS;
            let data = {
              name: "buscarcentroDeCostosGestion",
              parameters : {companiasId:companiasId}
            }
            let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
            let options = new RequestOptions({ headers: headers }) // Create a request option

            return this.http.post(`${url_servicio}/procedure`, data, options);
      }

      buscarCentroDeCostosGestionPorTipo (companiasId:any,tipo:any){
        let url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "buscarcentroDeCostosGestionPorTipo",
          parameters : {companiasId:companiasId, tipo:tipo}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option

        return this.http.post(`${url_servicio}/procedure`, data, options);
  }
}



// WEBPACK FOOTER //
// ./src/providers/centro-de-costos/centro-de-costos.ts